export default __webpack_public_path__ + "static/media/reporting-office-outline-16px.24896936.svg";